import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "../../navbar/Navbar";
import LinkToRegistration from "../../property/component/LinkToRegistration";
import Stepper from "../../Stepper/component/Stepper";
import { completeStep, nextStep } from "../../Stepper/stepperSlice";
import {
  fetchLoggedInUserInfoAsync,
  fetchPDEInfoAsync,
  selectLatestEvaluation,
  selectPDEInfo,
  selectUserEvaluations,
} from "../../user/userSlice";
import { selectAuthToken, selectLoggedInUser } from "../../auth/authSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { selectPdEId } from "../../property/propertySlice";
import API_BASE_URL from "../../BaseURL/baseURL";
import { toast } from "react-toastify";
import { selectActiveTab, setActiveTab } from "../tabSlice";
import axios from "axios";
import axiosInstance from "../../BaseURL/axiosInstance";
import { previewDeed } from "../../uploadDocument/UploadDocumentSlice";

const OnlinePayment = () => {
  const dispatch = useDispatch();
  const evaluations = useSelector(selectUserEvaluations);
  const latestEvaluation = useSelector(selectLatestEvaluation);
  const user = useSelector(selectLoggedInUser);
  const navigate = useNavigate();
  const token = useSelector(selectAuthToken);
  // const [activeTab, setActiveTab] = useState("StampDuty");
  const activeTab = useSelector(selectActiveTab);
  const [isLoading, setIsLoading] = useState(false);

  // useEffect(() => {
  //   dispatch(fetchLoggedInUserInfoAsync(user.email));
  // }, [dispatch, user.email]);

  useEffect(() => {
    debugger;
    if (user && token) {
      setIsLoading(true);
      dispatch(fetchLoggedInUserInfoAsync(user.email)).finally(() =>
        setIsLoading(false)
      );
    }
  }, [dispatch, user]);

  useEffect(() => {
    if (latestEvaluation) {
      console.log("Latest Evaluation:", latestEvaluation);
    }
  }, [latestEvaluation]);

  useEffect(() => {
    if (evaluations) {
      console.log("Evaluation:", evaluations);
    }
  }, [evaluations]);

  const FormSwitch = ({ activeTab }) => {
    switch (activeTab) {
      case "StampDuty":
        return <StampDutyForm />;
      case "RegistrationFees":
        return <RegistrationFeesForm />;
      default:
        return <StampDutyForm />;
    }
  };

  return (
    <>
      <Navbar />
      <LinkToRegistration />
      {/* <div className="flex min-h-screen bg-white"> */}
      <div className="flex flex-grow bg-white">
        <div className="w-1/5 bg-white py-4 flex justify-center">
          <Stepper />
        </div>
        <div className="w-0.5 bg-neutral-400"></div>
        <div className="w-4/5 p-6 flex justify-center">
          <div className="w-full max-w-4xl bg-white">
            <div className="grid md:grid-cols-4 grid-cols-2 gap-0.5">
              <button
                // onClick={() => setActiveTab("StampDuty")}
                onClick={() => dispatch(setActiveTab("StampDuty"))}
                className={`py-2 text-center grid-cols-1 ${
                  activeTab === "StampDuty"
                    ? "bg-blue-500 text-white"
                    : "bg-gray-100 text-black"
                } `}
              >
                Stamp Duty
              </button>
              <button
                // onClick={() => setActiveTab("RegistrationFees")}
                onClick={() => dispatch(setActiveTab("RegistrationFees"))}
                className={`py-2 text-center grid-cols-1 ${
                  activeTab === "RegistrationFees"
                    ? "bg-blue-500 text-white"
                    : "bg-gray-100 text-black"
                }`}
              >
                Registration Fees
              </button>
            </div>
            <div className="p-6 border-2 border-gray-400">
              {/* <h6 className="text-sm font-semibold">STAMP DUTY DETAILS</h6> */}

              <div className="text-black text-sm font-semibold mb-4 md:w-3/5 w-full bg-gray-100 mt-2">
                <FormSwitch activeTab={activeTab} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

//testing stamp starts

const StampDutyForm = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  // Redux state
  const pde = useSelector(selectPdEId);
  const pdeInfo = useSelector(selectPDEInfo);
  const pdeData = pdeInfo?.pdeData?.[0] || {};
  const appointmentType = useSelector(
    (state) => state.Procedure.appointmentType
  );
  const paymentStatus = pdeInfo?.paymentStatus?.[0] || {};
  const { stampStatus } = paymentStatus;
  debugger;
  // Local UI state
  const [error, setError] = useState(null);
  const [isStampPaid, setIsStampPaid] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Offline");
  const [modeStampPaymentFee, setModeStampPaymentFee] = useState([]);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const fname =
    pdeInfo?.partyDetails?.[0]?.savesecondparty?.[0]?.name_Eng ?? "";

  // Form data
  const [stampfeeData, setStampfeeData] = useState({
    paymentModeCode: "",
    paymentrefNo: "",
    stampLicenseNo: "",
    amount: pdeData.stampduty || 0,
    stampIssueDate: "",
  });

  // Helper: convert "DD-MM-YYYY HH:mm:ss" into ISO string
  const toIso = (dtString) => {
    if (!dtString) return new Date().toISOString();
    const [datePart, timePart] = dtString.split(" ");
    const [dd, mm, yyyy] = datePart.split("-");
    return new Date(`${yyyy}-${mm}-${dd}T${timePart}`).toISOString();
  };

  useEffect(() => {
    setSelectedOption(appointmentType === "P" ? "Offline" : "Online");
  }, [appointmentType]);

  // 1) On mount, insert any response params back into our DB
  useEffect(() => {
    const insertResponse = async () => {
      const params = new URLSearchParams(location.search);
      const AppId = params.get("AppId");
      if (!AppId) return;

      const payload = {
        AppId,
        DeptRefNo: params.get("DeptRefNo"),
        CertNo: params.get("CertNo"),
        UniqueDocRef: params.get("UniqueDocRef"),
        CertCreationDate: toIso(params.get("CertCreationDate")),
        StampDutyType: params.get("StampDutyType"),
        PropDescrition: params.get("PropDescrition"),
        FirstParty: params.get("FirstParty"),
        SecondParty: params.get("SecondParty"),
        StampDutyPaidBy: params.get("StampDutyPaidBy"),
        StampDuty: params.get("StampDuty"),
        TotalAmt: params.get("TotalAmt"),
        BankRefNo: params.get("BankRefNo"),
        PymtUniqueRefNo: params.get("PymtUniqueRefNo"),
        PymtStatus: params.get("PymtStatus"),
        PymtDateTime: toIso(params.get("PymtDateTime")),
        PymtMethod: params.get("PymtMethod"),
        PymtStatusNote: params.get("PymtStatusNote"),
      };

      try {
        await axiosInstance.post(
          "/OnlinePayment/insert_stamp_payment_response",
          payload
        );
      } catch (err) {
        console.error("insert_stamp_payment_response failed:", err);
      }
    };

    insertResponse();
  }, [location.search]);

  // 2) Fetch PDE info when pde changes
  useEffect(() => {
    if (pde) dispatch(fetchPDEInfoAsync(pde));
  }, [dispatch, pde]);

  // 3) If stamp status in Redux says SUCCESS, mark as paid
  useEffect(() => {
    if (stampStatus === "SUCCESS") {
      setIsStampPaid(true);
    }
  }, [stampStatus]);

  // 4) Load payment-mode options
  useEffect(() => {
    const fetchModes = async () => {
      try {
        const resp = await axiosInstance.get(
          "/OnlinePayment/getModePaymentStamp"
        );
        setModeStampPaymentFee(resp.data);
      } catch (err) {
        console.error("Error fetching payment modes:", err);
      }
    };
    fetchModes();
  }, []);

  // 5) Preview deed PDF
  const PreviewDeed = () => {
    setLoadingPreview(true);
    dispatch(previewDeed(pde))
      .unwrap()
      .then((base64) => {
        const bytes = atob(base64);
        const arr = new Uint8Array(bytes.length);
        for (let i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i);
        const blob = new Blob([arr], { type: "application/pdf" });
        window.open(URL.createObjectURL(blob), "_blank");
      })
      .catch((err) => alert(`Preview failed: ${err}`))
      .finally(() => setLoadingPreview(false));
  };

  // 6) Generic change handler
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    let parsed = value;
    if (type === "number") parsed = parseFloat(value) || 0;
    setStampfeeData((prev) => ({ ...prev, [name]: parsed }));
  };

  // 7) Submit (offline or online)
  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      setError(null);
      setSubmitting(true);

      const stampFeePayload = {
        PDE_ID: pde,
        Sr_No: 1,
        Payment_Mode_Code: stampfeeData.paymentModeCode,
        Amount: stampfeeData.amount,
        Payment_ref_no: stampfeeData.paymentrefNo,
        Stamp_Issue_Date: stampfeeData.stampIssueDate,
        Stamp_Vendor_Id: stampfeeData.stampLicenseNo,
        Status: "SUCCESS",
      };

      // OFFLINE PAYMENT
      if (selectedOption === "Offline") {
        try {
          await axiosInstance.post(
            "/OnlinePayment/insert_stamp_details",
            stampFeePayload
          );
          setIsStampPaid(true);
          toast.success("StampDuty details submitted successfully!");
        } catch (err) {
          setError("Submission failed, please try again.");
          toast.error("Submission failed, please try again.");
        } finally {
          setSubmitting(false);
        }
        return;
      }

      // ONLINE PAYMENT
      try {
        const { data } = await axiosInstance.post(
          "/OnlinePayment/check_stamp_payment_status",
          null,
          { params: { pde_id: pde } }
        );
        debugger;

        switch (data.type) {
          case "redirect": {
            debugger;
            // redirect to payment gateway
            const form = document.createElement("form");
            form.method = "POST";
            form.action =
              "https://eregistration.uk.gov.in/Online_StamppaymentNewWithDV.aspx";
            const params = {
              rfee: stampfeeData.amount,
              OPSdataForOnlVend: data.encryptedpayload,
              Appno: pde,
              name: fname,
              status: 1,
            };
            Object.entries(params).forEach(([k, v]) => {
              const inp = document.createElement("input");
              inp.type = "hidden";
              inp.name = k;
              inp.value = v;
              form.appendChild(inp);
            });
            document.body.appendChild(form);
            form.submit();
            break;
          }

          case "error":
            debugger;
            setError(data.message);
            toast.error(data.message);
            break;

          case "status": {
            debugger;
            // parse the incoming payload
            const details = JSON.parse(data.payload);

            // convert "dd-MM-yyyy HH:mm:ss" → ISO
            const toIso = (dstr) => {
              const [datePart, timePart] = dstr.split(" ");
              const [dd, MM, yyyy] = datePart.split("-");
              return new Date(`${yyyy}-${MM}-${dd}T${timePart}`).toISOString();
            };
            const isoCertDate = toIso(details.CertCreationDate);
            const isoPymtDate = toIso(details.PymtDateTime);

            // build the flat request body
            const verificationPayload = {
              AppId: details.AppId,
              DeptRefNo: details.DeptRefNo,
              CertNo: details.CertNo,
              UniqueDocRef: details.UniqueDocRef,
              CertCreationDate: isoCertDate,
              StampDutyType: details.StampDutyType,
              PropDescrition: details.PropDescrition,
              FirstParty: details.FirstParty,
              SecondParty: details.SecondParty,
              StampDutyPaidBy: details.StampDutyPaidBy,
              StampDuty: details.StampDuty,
              TotalAmt: details.TotalAmt,
              BankRefNo: details.BankRefNo,
              PymtUniqueRefNo: details.PymtUniqueRefNo,
              PymtStatus: details.PymtStatus,
              PymtDateTime: isoPymtDate,
              PymtMethod: details.PymtMethod,
              PymtStatusNote: details.PymtStatusNote,
            };

            const resp = await axiosInstance.post(
              "/OnlinePayment/double_verification",
              verificationPayload
            );
            debugger;
            if (resp.data.success) {
              const ok = data.status === "SUCCESS";
              setIsStampPaid(ok);
              toast[ok ? "success" : "warn"](
                ok
                  ? "Payment verified successfully!"
                  : "Payment failed but logged for review."
              );
            } else {
              setError("Could not log verification. Please contact support.");
              toast.error(
                "Could not log verification. Please contact support."
              );
            }
            break;
          }

          default:
            throw new Error("Unexpected response type");
        }
      } catch (err) {
        console.error(err);
        setError("Submission failed, please try again.");
        toast.error("Submission failed, please try again.");
      } finally {
        setSubmitting(false);
      }
    },
    [selectedOption, stampfeeData, pde, fname]
  );

  return (
    <div className="p-4">
      {isStampPaid && (
        <div className="flex justify-end mb-4">
          <button
            onClick={PreviewDeed}
            disabled={loadingPreview}
            className="px-4 py-2 bg-gray-100 text-blue-600 rounded hover:bg-gray-200 disabled:opacity-50"
          >
            {loadingPreview ? "Loading..." : "Preview Deed"}
          </button>
        </div>
      )}

      <h4 className="text-sm font-semibold">Stamp Fees Details</h4>
      <div className="flex gap-4 mb-4 mt-2">
        {appointmentType === "P" && (
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name="toggle"
              value="Offline"
              checked={selectedOption === "Offline"}
              onChange={() => setSelectedOption("Offline")}
              className="w-4 h-4"
            />
            Offline
          </label>
        )}
        {appointmentType !== "P" && (
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name="toggle"
              value="Online"
              checked={selectedOption === "Online"}
              onChange={() => setSelectedOption("Online")}
              className="w-4 h-4"
            />
            Online
          </label>
        )}
      </div>

      {selectedOption === "Online" ? (
        <div className="m-2 py-2">
          {error && <div className="text-red-500 text-sm mb-2">{error}</div>}

          {/* PDE & rates info */}
          <div className="grid gap-4 m-2 text-sm">
            <div className="flex justify-between">
              <span>PDE ID:</span>
              <span className="text-blue-600">{pdeData.pdE_ID}</span>
            </div>
            <div className="flex justify-between">
              <span>Circle Rate:</span>
              <span className="text-blue-600">
                ₹ {pdeData.circle_rate || 0}
              </span>
            </div>
            <div className="flex justify-between">
              <span>Land/Floor Value:</span>
              <span className="text-blue-600">₹ {pdeData.landcost || 0}</span>
            </div>
            <div className="flex justify-between">
              <span>Govt.Value:</span>
              <span className="text-blue-600">₹ {pdeData.mvalue || 0}</span>
            </div>
            <div className="flex justify-between">
              <span>Structure Value:</span>
              <span className="text-blue-600">₹ {pdeData.structcost || 0}</span>
            </div>
            <div className="flex justify-between">
              <span>Total StampDuty:</span>
              <span className="text-blue-600">₹ {pdeData.stampduty || 0}</span>
            </div>
          </div>

          {!isStampPaid ? (
            <div className="flex justify-start mt-5">
              <button
                onClick={handleSubmit}
                disabled={submitting}
                className="px-6 py-1.5 bg-blue-500 text-white rounded-full text-sm disabled:opacity-50"
              >
                {submitting ? "Submitting..." : "Pay Stamp Duty"}
              </button>
            </div>
          ) : (
            <div className="flex justify-center mt-5">
              <span className="py-1.5 text-green-400 font-semibold text-xl">
                Stamp Duty Paid!
              </span>
            </div>
          )}
        </div>
      ) : (
        <div className="m-2 py-2">
          {error && <div className="text-red-500 text-sm mb-2">{error}</div>}

          <div className="grid md:grid-cols-2 gap-4 m-2">
            <label className="my-auto">Mode:</label>
            <select
              name="paymentModeCode"
              value={stampfeeData.paymentModeCode}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
            >
              <option value="">Select mode…</option>
              {modeStampPaymentFee.map((opt) => (
                <option key={opt.payment_code} value={opt.payment_code}>
                  {opt.payment_type}
                </option>
              ))}
            </select>
          </div>

          <div className="grid md:grid-cols-2 gap-4 m-2">
            <label className="my-auto">Amount:</label>
            <input
              type="number"
              name="amount"
              value={stampfeeData.amount}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
            />
          </div>

          <div className="grid md:grid-cols-2 gap-4 m-2">
            <label className="my-auto">Challan/e-Payment Ref. No:</label>
            <input
              type="text"
              name="paymentrefNo"
              value={stampfeeData.paymentrefNo}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
            />
          </div>

          <div className="grid md:grid-cols-2 gap-4 m-2">
            <label className="my-auto">Stamp Issue Date:</label>
            <input
              type="date"
              name="stampIssueDate"
              value={stampfeeData.stampIssueDate}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
            />
          </div>

          <div className="grid md:grid-cols-2 gap-4 m-2">
            <label className="my-auto">Stamp Vendor License No:</label>
            <input
              type="text"
              name="stampLicenseNo"
              value={stampfeeData.stampLicenseNo}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
            />
          </div>

          {!isStampPaid ? (
            <div className="flex justify-start mt-5">
              <button
                onClick={handleSubmit}
                disabled={submitting}
                className="px-6 py-1.5 bg-blue-500 text-white rounded-full text-sm disabled:opacity-50"
              >
                {submitting ? "Submitting..." : "Add StampDuty Details"}
              </button>
            </div>
          ) : (
            <div className="flex justify-center mt-5">
              <span className="py-1.5 text-green-400 font-semibold text-xl">
                StampDuty Details Submitted
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const RegistrationFeesForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const location = useLocation();

  const pde = useSelector(selectPdEId);
  const pdeInfo = useSelector(selectPDEInfo);
  const pdeData = pdeInfo?.pdeData[0];
  const appointmentType = useSelector(
    (state) => state.Procedure.appointmentType
  );
  const PaymentStatus = pdeInfo?.paymentStatus[0];
  const { rfeeStatus, result } = PaymentStatus || {};
  const currentStep = useSelector((state) => state.stepper.currentStep);
  const appointmentStatus = pdeInfo?.appointmentStatus[0]?.modifyFlag;
  const [isRegistrationPaid, setIsRegistrationPaid] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Offline");
  const [modePaymentFee, setModePaymentFee] = useState([]);
  const [banknameOption, setBankName] = useState([]);

  const [regfeeData, setRegfeeData] = useState({
    paymentModeCode: "",
    paymentrefNo: "",
    bankName: "",
    banknameCode: "",
    amount: pdeData?.rfee || 0,
    paymentDate: "",
  });

  useEffect(() => {
    setSelectedOption(appointmentType === "P" ? "Offline" : "Online");
  }, [appointmentType]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const mode = queryParams.get("mode");
    const pde_id = queryParams.get("pde_id");
    const merchantorderno = queryParams.get("merchantorderno");
    const sbiepayreferenceid = queryParams.get("sbiepayreferenceid");

    if (merchantorderno && sbiepayreferenceid) {
      const paymentData = {
        merchantorderno,
        sbiepayreferenceid,
        status: queryParams.get("status"),
        amount: parseFloat(queryParams.get("amount")),
        currency: queryParams.get("currency"),
        paymode: queryParams.get("paymode"),
        otherdetails: queryParams.get("otherdetails"),
        reason: queryParams.get("reason"),
        bankcode: queryParams.get("bankcode"),
        bankreferenceno: queryParams.get("bankreferenceno"),
        transactiondate: queryParams.get("transactiondate"),
        country: queryParams.get("country"),
        challanidentificationno: queryParams.get("challanidentificationno"),
        pde,
      };

      if (mode === "firstResponse") {
        axios
          .post(
            `${API_BASE_URL}/OnlinePayment/insert_rfee_details_firstresponse_Online`,
            paymentData
          )
          .then((response) => {
            if (response.status === 200) {
              setIsRegistrationPaid(true);
              toast.success("Registration Fee Submitted Successfully !!");
              dispatch(completeStep({ step: currentStep }));
              dispatch(nextStep());
              if (appointmentStatus === "N") {
                navigate("/OnlineAppointment");
              }
            }
          })
          .catch((error) =>
            console.error("Error saving payment response:", error)
          );
      } else {
        axios
          .post(
            `${API_BASE_URL}/OnlinePayment/insert_rfee_details_DoubleVerification_Online`,
            paymentData
          )
          .catch((error) =>
            console.error("Error saving payment response:", error)
          );
      }
    }
  }, [
    location.search,
    pde,
    dispatch,
    currentStep,
    appointmentStatus,
    navigate,
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRegfeeData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleBankNameChange = (e) => {
    const { name, value } = e.target;
    const selectedValue = parseInt(value, 10);
    const selectedBank = banknameOption.find(
      (opt) => opt.bank_Code === selectedValue
    );
    setRegfeeData((prevData) => ({
      ...prevData,
      [name]: value,
      bankName: selectedBank?.bank_name || "",
    }));
  };

  useEffect(() => {
    if (rfeeStatus === "SUCCESS") {
      setIsRegistrationPaid(true);
    }
  }, [result, rfeeStatus]);

  useEffect(() => {
    if (pde) {
      dispatch(fetchPDEInfoAsync(pde));
    }
  }, [dispatch, pde]);

  useEffect(() => {
    fetchBankName();
    fetchModePaymentFee();
  }, []);

  const regFeePayload = {
    PDE_ID: pde,
    sr_No: 1,
    payment_Mode_Code: regfeeData.paymentModeCode,
    amount: regfeeData.amount,
    payment_ref_no: regfeeData.paymentrefNo,
    payment_Date: regfeeData.paymentDate,
    bank_Name: regfeeData.bankName,
    bank_Code: regfeeData.banknameCode,
    Status: "SUCCESS",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    const isPhysical = selectedOption === "Offline";

    if (isPhysical) {
      try {
        const response = await axiosInstance.post(
          "/OnlinePayment/insert_rfee_details",
          regFeePayload
        );
        if (response.status === 200) {
          setIsRegistrationPaid(true);
          toast.success("Registration Fee Submitted Successfully !!");
          dispatch(completeStep({ step: currentStep }));
          dispatch(nextStep());
          if (appointmentStatus === "N") {
            navigate("/OnlineAppointment");
          }
        }
      } catch (error) {
        console.error("Error:", error);
        setError("Submission failed, please try again.");
      }
    } else {
      try {
        const response = await axiosInstance.get(
          `/OnlinePayment/GetOnlinePaymentDetails?pde_id=${pde}`
        );
        debugger;
        if (response.data.status === 1) {
          const params = {
            rfee: response.data.rFee,
            merchant_id: response.data.merchantId,
            Appno: pde,
            name: response.data.name,
            status: response.data.status,
          };
          const form = document.createElement("form");
          form.method = "POST";
          form.action =
            "https://eregistration.uk.gov.in/Online_EpaymentNewWithDV.aspx";
          form.style.display = "none";
          Object.entries(params).forEach(([key, value]) => {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = key;
            input.value = value;
            form.appendChild(input);
          });
          document.body.appendChild(form);
          form.submit();
        } else {
          console.error("API call failed with status:", response.status);
        }
      } catch (error) {
        console.error("Error during API call:", error);
        setError("Submission failed, please try again.");
      }
    }
  };

  const fetchModePaymentFee = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/OnlinePayment/getModePaymentFee`
      );
      if (!response.ok) throw new Error("Failed to fetch data");
      const data = await response.json();
      setModePaymentFee(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchBankName = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/OnlinePayment/GetBankName`);
      if (!response.ok) throw new Error("Failed to fetch data");
      const data = await response.json();
      setBankName(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div className="p-4">
      <h6 className="text-sm font-semibold">Registration Fees Details</h6>
      <div className="flex gap-4 mb-4">
        {appointmentType === "P" && (
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name="toggle"
              value="Offline"
              checked={selectedOption === "Offline"}
              onChange={() => setSelectedOption("Offline")}
              className="w-4 h-4"
            />
            Offline
          </label>
        )}
        {appointmentType !== "P" && (
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name="toggle"
              value="Online"
              checked={selectedOption === "Online"}
              onChange={() => setSelectedOption("Online")}
              className="w-4 h-4"
            />
            Online
          </label>
        )}
      </div>

      {selectedOption === "Online" && (
        <div className="m-2 py-2">
          {error && <div className="text-red-500 text-sm">{error}</div>}
          <div className="grid md:grid-cols-1 gap-4 m-2">
            <div className="flex justify-between text-sm">
              <span>PDE ID:</span>
              <span className=" text-blue-600">{pdeData?.pdE_ID ?? ""}</span>
            </div>
          </div>
          <div className="grid md:grid-cols-1 gap-4 m-2">
            <div className="flex justify-between text-sm">
              <span>Circle Rate:</span>
              <span className=" text-blue-600">
                {"₹" + " " + (pdeData?.circle_rate ?? 0)}
              </span>
            </div>
          </div>
          <div className="grid md:grid-cols-1 gap-4 m-2">
            <div className="flex justify-between text-sm">
              <span>Land/Floor Value:</span>
              <span className=" text-blue-600">
                {"₹" + " " + (pdeData?.landcost ?? 0)}
              </span>
            </div>
          </div>
          <div className="grid md:grid-cols-1 gap-4 m-2">
            <div className="flex justify-between text-sm">
              <span>Govt.Value:</span>
              <span className=" text-blue-600">
                {"₹" + " " + (pdeData?.mvalue ?? 0)}
              </span>
            </div>
          </div>
          <div className="grid md:grid-cols-1 gap-4 m-2">
            <div className="flex justify-between text-sm">
              <span>Structure Value:</span>
              <span className=" text-blue-600">
                {"₹" + " " + (pdeData?.structcost ?? 0)}
              </span>
            </div>
          </div>
          <div className="grid md:grid-cols-1 gap-4 m-2">
            <div className="flex justify-between text-sm">
              <span>Total Pages:</span>
              <span className=" text-blue-600">{pdeData?.page ?? 0}</span>
            </div>
          </div>
          <div className="grid md:grid-cols-1 gap-4 m-2">
            <div className="flex justify-between text-sm">
              <span>Pasting Fee:</span>
              <span className=" text-blue-600">
                {"₹" + " " + (pdeData?.pasting ?? 0)}
              </span>
            </div>
          </div>
          <div className="grid md:grid-cols-1 gap-4 m-2">
            <div className="flex justify-between text-sm">
              <span> EPF:</span>
              <span className=" text-blue-600">
                {"₹" + " " + (pdeData?.page * 10 ?? 0)}
              </span>
            </div>
          </div>
          <div className="grid md:grid-cols-1 gap-4 m-2">
            <div className="flex justify-between text-sm">
              <span>Registration Fees:</span>
              <span className=" text-blue-600">
                {"₹" + " " + (pdeData?.rfee ?? 0)}
              </span>
            </div>
          </div>
          <div className="grid md:grid-cols-1 gap-4 m-2">
            <div className="flex justify-between text-sm">
              <span>Total Fees:</span>
              <span className=" text-blue-600">
                {"₹ " +
                  ((pdeData?.rfee ?? 0) +
                    (pdeData?.pasting ?? 0) +
                    (pdeData?.page * 10 ?? 0))}
              </span>
            </div>
          </div>

          {isRegistrationPaid ? (
            <div className="flex justify-center mt-5 gap-2">
              <span className="py-1.5 m-2  text-green-400 font-semibold  text-xl">
                Registration Fees Paid!
              </span>
            </div>
          ) : (
            <div className="flex justify-start mt-5 gap-2">
              <button
                className="px-6 py-1.5 m-2 bg-blue-500 text-white rounded-full text-sm"
                onClick={handleSubmit}
              >
                Pay Registration Fees
              </button>
            </div>
          )}
        </div>
      )}

      {selectedOption === "Offline" && (
        <div className="m-2 py-2">
          {error && <div className="text-red-500 text-sm">{error}</div>}
          <div className="grid md:grid-cols-1 gap-4 m-2">
            <div className="flex justify-between text-sm">
              <span>PDE ID:</span>
              <span className=" text-blue-600">{pdeData?.pdE_ID ?? ""}</span>
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-4 m-2">
            <span className="my-auto">Mode:</span>
            <select
              name="paymentModeCode"
              value={regfeeData.paymentModeCode}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
            >
              {modePaymentFee.map((option) => (
                <option key={option.payment_code} value={option.payment_code}>
                  {option.payment_type}
                </option>
              ))}
            </select>
          </div>

          <div className="grid md:grid-cols-2 gap-4 m-2">
            <span className="my-auto">Amount:</span>
            <input
              type="number"
              name="amount"
              value={regfeeData.amount}
              onChange={(e) =>
                setRegfeeData({
                  ...regfeeData,
                  amount: parseFloat(e.target.value) || 0,
                })
              }
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
            />
          </div>

          <div className="grid md:grid-cols-2 gap-4 m-2">
            <span className="my-auto">Bank Name:</span>
            <select
              name="banknameCode"
              value={regfeeData.banknameCode}
              onChange={handleBankNameChange}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
            >
              <option value="" disabled>
                --Select--
              </option>
              {banknameOption.map((option) => (
                <option key={option.bank_Code} value={option.bank_Code}>
                  {option.bank_name}
                </option>
              ))}
            </select>
          </div>

          <div className="grid md:grid-cols-2 gap-4 m-2">
            <span className="my-auto"> Challan/e-Payment/DD/Ref. No:</span>
            <input
              type="text"
              name="paymentrefNo"
              value={regfeeData.paymentrefNo}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
            />
          </div>

          <div className="grid md:grid-cols-2 gap-4 m-2">
            <span className="my-auto"> Challan/e-Payment Date:</span>
            <input
              type="date"
              name="paymentDate"
              value={regfeeData.paymentDate}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
            />
          </div>

          {isRegistrationPaid ? (
            <div className="flex justify-center mt-5 gap-2">
              <span className="py-1.5 m-2  text-green-400 font-semibold  text-xl">
                Registration Fees Paid!
              </span>
            </div>
          ) : (
            <div className="flex justify-start mt-5 gap-2">
              <button
                className="px-6 py-1.5 m-2 bg-blue-500 text-white rounded-full text-sm"
                onClick={handleSubmit}
              >
                Add Registration Fees Details
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default OnlinePayment;
